/**
 * Utilitário de formatação de texto no padrão WhatsApp
 * Converte marcadores de texto (*negrito*, _itálico_, ~tachado~) em HTML
 * 
 * Versão: 1.0.0
 */
import DOMPurify from 'dompurify';

/**
 * Converte texto com formatação WhatsApp em HTML seguro
 * 
 * Suporta:
 * - *texto* → <strong>texto</strong> (negrito)
 * - _texto_ → <em>texto</em> (itálico)
 * - ~texto~ → <s>texto</s> (tachado)
 * - Quebras de linha preservadas via <br>
 * 
 * @param text - Texto com marcadores WhatsApp
 * @returns HTML sanitizado pronto para renderização
 */
export function formatWhatsAppText(text: string): string {
  if (!text) return '';

  let formatted = text
    // Negrito: *texto* → <strong>texto</strong>
    .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
    // Itálico: _texto_ → <em>texto</em>
    .replace(/_(.*?)_/g, '<em>$1</em>')
    // Tachado: ~texto~ → <s>texto</s>
    .replace(/~(.*?)~/g, '<s>$1</s>')
    // Quebras de linha
    .replace(/\n/g, '<br />');

  // Sanitiza permitindo apenas tags de formatação seguras
  return DOMPurify.sanitize(formatted, {
    ALLOWED_TAGS: ['strong', 'b', 'em', 'i', 's', 'br'],
    ALLOWED_ATTR: [],
  });
}
